import { render } from "./CartProductCard.vue?vue&type=template&id=2d0fb042&scoped=true&ts=true"
import script from "./CartProductCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartProductCard.vue?vue&type=script&setup=true&lang=ts"

import "./CartProductCard.vue?vue&type=style&index=0&id=2d0fb042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0fb042"],['__file',"src/components/CartProductCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d0fb042"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d0fb042', __exports__)) {
    api.reload('2d0fb042', __exports__)
  }
  
  module.hot.accept("./CartProductCard.vue?vue&type=template&id=2d0fb042&scoped=true&ts=true", () => {
    api.rerender('2d0fb042', render)
  })

}


export default __exports__